import Input from '@mui/material/Input'
import InputAdornment from '@mui/material/InputAdornment'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import type { InputBaseProps } from '@mui/material/InputBase'
import type { TCountry } from '@repo/unicity'
import type { ChangeEvent } from 'react'
import KeyLockedIcon from '../../assets/icons/svg/KeyLockedIcon.svg'

type InputBoxProps = {
    inputBaseProps?: InputBaseProps
    onChange?: (value: string) => void
    name?: string
    props?: unknown
    value?: string
    onClick?: () => void
    type?: string
    country?: TCountry
}

const CountryBox = ({ inputBaseProps, onChange, name, value = '', onClick, type = 'text', country, ...props }: InputBoxProps) => {
    return (
        <Stack width={'100%'}>
            <InputStyled
                fullWidth
                {...inputBaseProps}
                onChange={(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => onChange?.(e.target.value)}
                name={name}
                value={value || country?.roman_name}
                {...props}
                onClick={onClick}
                type={type}
                autoComplete={type === 'text' ? 'new-password' : undefined}
                startAdornment={
                    <InputAdornment position="start" sx={{ img: { boxShadow: '0px 1px 2px 0px rgba(55, 52, 52, 0.44)' } }}>
                        <img src={country?.flagUrl} alt={country?.roman_name} />
                    </InputAdornment>
                }
                endAdornment={
                    <InputAdornment position="end">
                        <img src={KeyLockedIcon} alt="key-locked" />
                    </InputAdornment>
                }
                disabled
            />
        </Stack>
    )
}

const InputStyled = styled(Input)(({ theme }: { theme: import('@mui/material/styles').Theme }) => ({
    'label + &': {
        marginTop: theme.spacing(1)
    },
    '&.MuiInputBase-root': {
        borderRadius: 8,
        position: 'relative',
        backgroundColor: '#F1F5F9',
        border: '1px solid',
        borderColor: '#E2E8F0',
        fontSize: '16px',
        width: '100%',
        padding: '14px 12px',
        color: '#003B6F',
        transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: 'Inter, NotoSansThai, Poppins',
        ...theme.applyStyles('dark', {
            backgroundColor: '#1A2027',
            borderColor: '#E2E8F0'
        }),
        '&::before': {
            content: '""',
            borderBottom: 'none'
        },
        '& .MuiInputBase-input.Mui-disabled': {
            color: '#003B6F',
            '-webkit-text-fill-color': '#003B6F',
            paddingTop: '0px',
            paddingBottom: '0px',
            backgroundColor: 'transparent'
        }
    }
}))

export default CountryBox
